
      import Drag from './drag.vue'
      import type { App, Plugin } from 'vue'

      export const DragPlugin: Plugin = {
        install(app: App) {
          app.component('Drag', Drag)
        },
      }
      export { Drag }
      